<template>
  <div class="card-modern">
  
    <!-- HEADER -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h3 class="card-title-modern">Master Spesifikasi Perangkat</h3>
  
    </div>
    <div class="d-flex align-items-center justify-content-end gap-2 mb-3 flex-wrap">
      <div style="position: relative; width: 150px;">
        <i class="bi bi-search text-muted"
          style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); z-index: 1;"></i>
        <input v-model="filters.search" class="form-control" placeholder="Cari"
          style="padding-left: 32px; border-radius: 8px;" @input="getData" />
      </div>
      <select v-model="filters.status" class="form-select" style="width: 150px;" @change="getData">
        <option value="">Semua Status</option>
        <option value="1">Active</option>
        <option value="0">Inactive</option>
      </select>
      <button class="button-modern" @click="openModal">+ Add Specification</button>
    </div>
    <!-- TABLE -->
    <div class="modern-table-wrapper">
      <table class="table-modern">
        <thead>
          <tr>
            <th>No</th>
            <th>Spesifikasi Perangkat</th>
            <th class="text-center">Status</th>
            <th class="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
  
          <!-- LOADING -->
          <tr v-if="loading">
            <td colspan="4" class="text-center py-4">
              <div class="spinner-border spinner-border-sm me-2"></div>
              Memuat data...
            </td>
          </tr>
  
          <!-- EMPTY -->
          <tr v-else-if="items.length === 0">
            <td colspan="4" class="text-center py-4 text-muted">
              Tidak ada data spesifikasi perangkat
            </td>
          </tr>
  
          <!-- DATA -->
          <tr v-else v-for="(item, index) in items" :key="item.specification_id">
            <td>{{ (page - 1) * perPage + index + 1 }}</td>
            <td>
              <span class="fw">{{ item.specification_name }}</span>
            </td>
            <td class="text-center">
              <span class="badge-modern" :class="item.status == 1 ? 'badge-success' : 'badge-danger'">
                {{ item.status == 1 ? 'Aktif' : 'Nonaktif' }}
              </span>
            </td>
            <td class="text-center">
              <button class="btn btn-sm bg-light border text-dark me-1" @click="openEdit(item)">
                <i class="bi bi-pencil me-1 text-warning"></i>Edit
              </button>
              <button class="btn btn-sm" :class="item.status == 1
                        ? 'bg-danger-subtle border border-danger-subtle text-danger-emphasis'
                        : 'bg-success-subtle border border-success-subtle text-success-emphasis'"
                @click="toggleStatus(item)" :title="item.status == 1 ? 'Nonaktifkan' : 'Aktifkan'">
                <i class="bi me-1" :class="item.status == 1 ? 'bi-slash-circle' : 'bi-check-circle'"></i>{{ item.status ==
                1 ? 'Nonaktifkan' : 'Aktifkan' }}
              </button>
            </td>
          </tr>
  
        </tbody>
      </table>
    </div>
  
    <!-- PAGINATION -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <small class="text-muted">
        Menampilkan {{ (page - 1) * perPage + 1 }} - {{ Math.min(page * perPage, total) }} dari {{ total }} data
      </small>
      <div class="d-flex align-items-center gap-2">
        <small class="text-muted">Rows per page</small>
        <select v-model.number="perPage" class="form-select form-select-sm" style="width: 70px;" @change="changePerPage">
          <option v-for="opt in perPageOptions" :key="opt" :value="opt">{{ opt }}</option>
        </select>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: page === 1 }">
              <button class="page-link" @click="changePage(page - 1)">&#8249;</button>
            </li>
            <li v-for="(p, idx) in visiblePages" :key="idx" class="page-item"
              :class="{ active: p === page, disabled: p === '...' }">
              <button class="page-link" @click="p !== '...' && changePage(p)">{{ p }}</button>
            </li>
            <li class="page-item" :class="{ disabled: page === totalPages }">
              <button class="page-link" @click="changePage(page + 1)">&#8250;</button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  
    <!-- MODAL ADD / EDIT -->
    <Teleport to="body">
      <div v-if="showModal" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.45);"
        @click.self="closeModal">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
  
            <div class="modal-header">
              <h5 class="modal-title">
                {{ isEdit ? 'Edit Spesifikasi Perangkat' : 'Tambah Spesifikasi Perangkat' }}
              </h5>
              <button type="button" class="btn-close" @click="closeModal"></button>
            </div>
  
            <div class="modal-body">
  
              <!-- Alert error dari API -->
              <div v-if="formError" class="alert alert-danger py-2 small mb-3">
                {{ formError }}
              </div>
  
              <!-- Nama Spesifikasi -->
              <div class="mb-3">
                <label class="form-label">
                  Spesifikasi Perangkat <span class="text-danger">*</span>
                </label>
                <input v-model="form.specification_name" type="text" class="form-control"
                  :class="{ 'is-invalid': errors.specification_name }"
                  placeholder="Masukkan nama spesifikasi perangkat..." @keyup.enter="saveForm" />
                <div v-if="errors.specification_name" class="invalid-feedback">
                  {{ errors.specification_name }}
                </div>
              </div>
  
              <!-- Status -->
              <div class="mb-3">
                <label class="form-label">Status</label>
                <select v-model.number="form.status" class="form-select">
                  <option :value="1">Active</option>
                  <option :value="0">Inactive</option>
                </select>
              </div>
  
            </div>
  
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeModal" :disabled="saving">
                Batal
              </button>
              <button type="button" class="btn btn-primary" @click="saveForm" :disabled="saving">
                <span v-if="saving">
                  <span class="spinner-border spinner-border-sm me-1"></span>
                  Menyimpan...
                </span>
                <span v-else>Simpan</span>
              </button>
            </div>
  
          </div>
        </div>
      </div>
    </Teleport>
  
    <!-- TOAST NOTIFICATION -->
    <div v-if="toast.show" :class="['alert', 'alert-' + toast.type, 'position-fixed']"
      style="top: 24px; right: 24px; z-index: 9999; min-width: 260px; box-shadow: 0 4px 12px rgba(0,0,0,0.15);"
      role="alert">
      {{ toast.message }}
    </div>
  
  </div>
</template>

<script>
import SpecificationView from "./SpecificationView";
export default SpecificationView;
</script>